const TALL_PORTRAIT = { width: 720, height: 1280 };
const PORTRAIT = { width: 1024, height: 1280 };
const SQUARE = { width: 1280, height: 1280 };
const LANDSCAPE = { width: 1280, height: 1024 };
const WIDE_LANDSCAPE = { width: 1280, height: 720 };

const getWidthAndHeightFromAspectRatio = (
  aspectRatio?: number, dimension?: string
): { width: number; height: number } => {
  if (aspectRatio) {
    if (aspectRatio > 0 && aspectRatio <= 0.5625) return TALL_PORTRAIT;
    if (aspectRatio > 0.5625 && aspectRatio <= 0.8) return PORTRAIT;
    if (aspectRatio > 0.8 && aspectRatio <= 1) return SQUARE;
    if (aspectRatio > 1 && aspectRatio <= 1.35) return LANDSCAPE;
    return WIDE_LANDSCAPE;
  }

  if (dimension) {
    switch (dimension) {
      case "tall-portrait":
        return TALL_PORTRAIT;
      case "portrait":
        return PORTRAIT;
      case "square":
        return SQUARE;
      case "landscape":
        return LANDSCAPE;
      case "wide-landscape":
        return WIDE_LANDSCAPE;
      default:
        break;
    }
  }
  return WIDE_LANDSCAPE;
};

export default getWidthAndHeightFromAspectRatio;
